import { render, staticRenderFns } from "./viewPriceing.vue?vue&type=template&id=d36ad906&scoped=true&"
import script from "./viewPriceing.vue?vue&type=script&lang=js&"
export * from "./viewPriceing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36ad906",
  null
  
)

export default component.exports